/* eslint-disable prettier/prettier */
import variables from "./variables"
import fuzzyAreas from "./fuzzyAreas"
import rules from "./rules"

export default {
    variables: variables,
    fuzzyAreas: fuzzyAreas,
    rules: rules
};